import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

export const APRE_FLIGHT_MONITOR_STATUSES = ["SCHEDULED", "DELAYED", "DEPARTED", "COMPLETED", "DIVERTED"];
export const FLIGHT_MONITOR_PATH = "/operation/flight-monitor";

export function getApreFlightMonitorTargetDate(flight) {
    const candidateDates = [flight?.atd, flight?.std, flight?.flight_date];

    for (const rawDate of candidateDates) {
        if (!rawDate) continue;
        const parsed = dayjs.utc(rawDate);
        if (parsed.isValid()) return parsed.format("YYYY-MM-DD");
    }

    return null;
}

export function buildApreFlightMonitorUrl(flight) {
    const params = new URLSearchParams();
    const aircraftReg = String(flight?.aircraft_reg || "").trim();
    const targetDate = getApreFlightMonitorTargetDate(flight);
    const flightId = flight?.flight_id ?? flight?.id;

    if (aircraftReg) {
        params.set("registrations", aircraftReg);
    }

    if (targetDate) {
        const center = dayjs.utc(targetDate);
        params.set("start_date", center.subtract(3, "day").format("YYYY-MM-DD"));
        params.set("end_date", center.add(3, "day").format("YYYY-MM-DD"));
    }

    params.set("status", APRE_FLIGHT_MONITOR_STATUSES.join(","));

    if (flightId !== null && flightId !== undefined && String(flightId).trim()) {
        params.set("flight_id", String(flightId));
        params.set("action", "open_detail");
    }

    return `${FLIGHT_MONITOR_PATH}?${params.toString()}`;
}
